import { ReactNode } from 'react'

import { cn } from '@/lib/utils'

export function PageContent({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={cn('p-8', className)}>{children}</div>
}
